import { createFileRoute, notFound } from '@tanstack/react-router';
import NotFound from '@src/pages/NotFound';
import { DEFAULT_WIDGETS } from '@src/pages/Dashboard/lib/defaultWidgets';

import { getLocalizedDynamicTitle } from '../title';

export const Route = createFileRoute('/_app/dashboard/$chartId')({
  loader: ({ params }) => {
    const widget = DEFAULT_WIDGETS.find((item) => item.id === params.chartId);
    if (!widget) {
      throw notFound();
    }

    return { widget };
  },
  head: ({ loaderData }) => ({
    meta: [
      {
        title: getLocalizedDynamicTitle(
          'dashboard.chart_details.page_title',
          'Chart',
          loaderData?.widget.title ?? '',
        ),
      },
    ],
  }),
  notFoundComponent: NotFound,
});
